import React from 'react'
import { Button } from '@components/Basic/ButtonNbe'
import { Icon } from 'semantic-ui-react'
import {
    StyledNewFeatureChip,
    StyledBannerWrapper,
    StyledHeading,
    StyledParagraph,
    StepImage,
} from '@features/nbee/StepCompleted/styled'
import { useTranslation } from 'react-i18next'
import DwhFinishImage from '@assets/images/illustrations/coming-soon.svg'
import { ApiErrorResponse, ApiPostDwhSettingsByBridgeIdResponse } from 'BackendApi'
import { usePostDwhSettingsByBridgeId } from '@app/api/postDwhSettingsByBridgeId'


interface Props {
    bridgeId: string
    existingDwhId?: number
  }


export const DwhBanner: React.FC<Props> = ({
    bridgeId,
    existingDwhId,
}) => {
    const { t } = useTranslation()
    const vueAppBaseUr = process.env.VUE_APP_BASE_URL

    const {
        mutateAsync: createDwh
    } = usePostDwhSettingsByBridgeId()

    const isCreatingPerformanceBooster = false
    const handleCreateDwhAndRedirect = async () => {
        if (existingDwhId === undefined){
            await createDwh(
                { bridgeId: bridgeId?.toString() || '' },
                {
                  onSuccess: (data: ApiPostDwhSettingsByBridgeIdResponse) => {
                    window.location.href = `${vueAppBaseUr}/dwh/${data?.data?.id}/edit`
                  },
                  onError: (error: ApiErrorResponse) => {
                    console.error(error)
                  },
                }
              )
        } else {
            window.location.href = `${vueAppBaseUr}/dwh/${existingDwhId}/edit`
        }   
    }



    return (
        <StyledBannerWrapper>
            <div style={{ minWidth: '385px' }}>
            <StyledNewFeatureChip>
                <Icon name='star' size={'tiny'} />
                <span
                    style={{
                    fontSize: '10px',
                    fontWeight: 600,
                    whiteSpace: 'nowrap',
                    }}
                >
                {t('dwh.bannerChip')}
                </span>
            </StyledNewFeatureChip>
            <StyledHeading>
                {existingDwhId ? t('dwh.bannerTitleEdit') : t('dwh.bannerTitle')}
            </StyledHeading>
            <StyledParagraph>
                {t('dwh.bannerP1')}
            </StyledParagraph>
            <StyledParagraph>
                {t('dwh.bannerP2')}
            </StyledParagraph>
            <Button
                $variant={'primary'}
                style={{}}
                $loading={isCreatingPerformanceBooster}
                onClick={handleCreateDwhAndRedirect}
            >
                {existingDwhId ? t('dwh.bannerCtaEdit') : t('dwh.bannerCta')}
            </Button>
            </div>
            <StepImage
                style={{ marginLeft: '16px', width: '282px' }}
                src={DwhFinishImage}
                alt={t('nbee.bridgeBuilder.step3Title')}
            />
        </StyledBannerWrapper>
    )
}